import { UserPartialDto } from "./UserPartialDto.js";
import { MediaDto } from "./MediaDto.js";
export class MaintenanceIssueDto {
    id;
    title;
    summary;
    status;
    addedById;
    addedBy;
    createdAt;
    recipientsTo;
    recipientsCC;
    medias;
    get images() {
        return this.medias.filter((m) => m.type === "Image");
    }
    get videos() {
        return this.medias.filter((m) => m.type === "Video");
    }
    constructor(obj) {
        Object.assign(this, obj);
    }
    static create(obj) {
        return new MaintenanceIssueDto(obj);
    }
}
//# sourceMappingURL=MaintenanceIssueDto.js.map